module.exports = __webpack_public_path__ + "img/project_idea.c3629dc1.png";